import React from 'react';
import { HerbSprig } from './HealingIcons';
export const Footer = () => <footer className="bg-brand-purpleDark text-white/85 py-12 border-t border-brand-gold/20" data-id="element-70" data-mp="3gf92wqh5nw6b">
    <div className="max-w-7xl mx-auto px-5 sm:px-6 lg:px-8 text-center" data-id="element-71" data-mp="3gh3swj7aaeh9">
      <div className="flex items-center justify-center gap-2 mb-3" aria-hidden="true" data-id="element-72" data-mp="32pp7k5pwm171">
        <HerbSprig className="w-6 h-6 opacity-80" color="#A6D93B" data-id="element-73" data-mp="36pzb7bq84fiq" />
        <HerbSprig className="w-8 h-8" color="#C9A961" data-id="element-74" data-mp="3uesbfkdvp9j5" />
        <HerbSprig className="w-6 h-6 opacity-80" color="#A6D93B" data-id="element-75" data-mp="3ucxs2ai99ph6" />
      </div>
      <p className="font-display font-bold text-2xl text-brand-goldLight" data-id="element-76" data-mp="387g3ogsjfgb">
        🌿 LUMEN AKASHA™
      </p>
      <p className="mt-2 text-white/75" data-id="element-77" data-mp="3le2f8fkphh4w">
        Recursos para acompañar tu estudio y dar más estructura a tu práctica.
      </p>

      <div className="mt-8 flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8 text-sm" data-id="element-78" data-mp="29zgkq0kfasm4">
        <a href="mailto:soportelumenakasha@gmail.com" className="hover:text-brand-goldLight transition-colors duration-150" data-id="element-79" data-mp="2ey05vyr700df">
          📧 soportelumenakasha@gmail.com
        </a>
        <a href="https://instagram.com/lumen.akasha" className="hover:text-brand-goldLight transition-colors duration-150" data-id="element-80" data-mp="3gaz73hu9bbqy">
          📲 @lumen.akasha
        </a>
        <a href="https://www.lumenakasha.com" className="hover:text-brand-goldLight transition-colors duration-150" data-id="element-81" data-mp="3q83t9ho3r77r">
          🌐 www.lumenakasha.com
        </a>
      </div>

      <p className="mt-10 text-xs text-white/50" data-id="element-82" data-mp="34gyblgf8z9p">
        © Lumen Akasha™ 2026. Todos los derechos reservados.
      </p>
    </div>
  </footer>;